module.exports = __webpack_public_path__ + "img/logout.bab52555.svg";